<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-level-track-level-field-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>


import VueTypes from "vue-types";

import RLevelTrackLevelFieldTable from "@/modules/redactor/views/level-track/level/field/r-level-track-level-field-table.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

import { LevelTrackLevelField } from "@/modules/redactor/models/level-track/LevelTrackLevelField";

export default {
  name: "r-level-track-level-field-panel",
  components: {RPanel, RLevelTrackLevelFieldTable},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Fields"),
    items: VueTypes.arrayOf(LevelTrackLevelField),
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
